import React, { useRef } from 'react';
import cx from 'classnames';
import { Range as Range$1 } from 'react-range';
import '../../../icons/ActivityIcon.js';
import '../../../icons/AgeIcon.js';
import '../../../icons/ArrowDownV2.js';
import '../../../icons/ArrowDownV3.js';
import '../../../icons/ArrowDown.js';
import '../../../icons/ArrowLeftBig.js';
import '../../../icons/ArrowLeft.js';
import '../../../icons/ArrowLeft2.js';
import '../../../icons/ArrowsDown.js';
import '../../../icons/ArrowsUp.js';
import '../../../icons/ArrowUpRightIcon.js';
import '../../../icons/Baccarat.js';
import '../../../icons/BlackJack.js';
import '../../../icons/BookIcon.js';
import '../../../icons/Calendar.js';
import '../../../icons/Carts.js';
import '../../../icons/ChartIcon.js';
import '../../../icons/ChainIcon.js';
import '../../../icons/CheckIcon2.js';
import '../../../icons/CheckIcon.js';
import '../../../icons/Checks.js';
import '../../../icons/ChevronDown.js';
import '../../../icons/Clock.js';
import '../../../icons/Close.js';
import '../../../icons/CoinsIcon.js';
import '../../../icons/Coins.js';
import '../../../icons/CopyIconDouble.js';
import '../../../icons/CopyIconFill.js';
import '../../../icons/Crown.js';
import '../../../icons/CryptoCurrency.js';
import '../../../icons/DiscordIcon.js';
import '../../../icons/DiscordIconV2.js';
import '../../../icons/Dota2.js';
import '../../../icons/Edit.js';
import '../../../icons/ExtendIcon.js';
import '../../../icons/EyeOff.js';
import '../../../icons/Eye.js';
import '../../../icons/FacebookIconV2.js';
import '../../../icons/FacebookIcon.js';
import '../../../icons/FiatCurrency.js';
import '../../../icons/FilterIcon.js';
import '../../../icons/GameIcon.js';
import '../../../icons/GameShows.js';
import '../../../icons/Game.js';
import '../../../icons/HeadPhones.js';
import '../../../icons/HomeIcon.js';
import '../../../icons/Horse.js';
import '../../../icons/InfoFill.js';
import '../../../icons/InfoIcon2.js';
import '../../../icons/InfoIcon.js';
import '../../../icons/InfoOutline.js';
import '../../../icons/LevelUp.js';
import '../../../icons/LinkIcon.js';
import '../../../icons/Link.js';
import '../../../icons/LiveCasino.js';
import '../../../icons/LiveIcons2.js';
import '../../../icons/LobbyIconV2.js';
import '../../../icons/LobbyIcon.js';
import '../../../icons/LogoSmallIcon.js';
import { Lock } from '../../../icons/Lock.js';
import '../../../icons/LOL.js';
import '../../../icons/MaxIcon.js';
import '../../../icons/MedalIcon.js';
import '../../../icons/MedalStarIcon.js';
import '../../../icons/MoneyBagIcon.js';
import '../../../icons/MoneyIcon.js';
import '../../../icons/MoneyRecive.js';
import '../../../icons/NewTwitterIcon.js';
import '../../../icons/OriginalsIcon.js';
import '../../../icons/Original.js';
import '../../../icons/PersonIcon.js';
import '../../../icons/PhoneChatIcon.js';
import '../../../icons/PhotoUp.js';
import '../../../icons/PlayIcon.js';
import '../../../icons/PlusIcon.js';
import '../../../icons/RainIcon.js';
import '../../../icons/RankIcon.js';
import '../../../icons/RankinIcon.js';
import '../../../icons/ReferalIcon.js';
import '../../../icons/RefreshIcon.js';
import '../../../icons/Reload.js';
import '../../../icons/Roulette.js';
import '../../../icons/Search2Icon.js';
import '../../../icons/Search.js';
import '../../../icons/SendIcon.js';
import '../../../icons/Settings2.js';
import '../../../icons/SettingsV3.js';
import '../../../icons/Settings.js';
import '../../../icons/SlotsIcon2.js';
import '../../../icons/SlotsIcon.js';
import '../../../icons/SmileIcon.js';
import '../../../icons/SocialsIcon.js';
import '../../../icons/SortIcon.js';
import '../../../icons/SponsorshipIcon.js';
import '../../../icons/StarFill.js';
import '../../../icons/StarCraft.js';
import '../../../icons/StopIcon.js';
import '../../../icons/TableGamesIcon.js';
import '../../../icons/TelegramIcon.js';
import '../../../icons/TelegramIconV2.js';
import '../../../icons/TopPicksIcon.js';
import '../../../icons/Upload.js';
import '../../../icons/UserMoney.js';
import '../../../icons/UsersIconV2.js';
import '../../../icons/UsersIcon.js';
import '../../../icons/VerifiedIcon.js';
import '../../../icons/WalletAddIcon.js';
import '../../../icons/Wallet.js';
import '../../../icons/WarningIcon.js';
import '../../../icons/DeviceDesktop.js';
import '../../../icons/DeviceTablet.js';
import '../../../icons/DevicePhone.js';
import '../../../icons/ClockOrange.js';
import '../../../icons/CalendarOrange.js';
import '../../../icons/OpenLinkIcon.js';
import '../../../icons/FavoriteFill.js';
import '../../../icons/EditorChoiceV2.js';
import '../../../icons/ListBullet.js';
import '../../../icons/BankIcon.js';
import '../../../icons/ClockOrangeV2.js';
import '../../../icons/CalendarOrangeV2.js';
import '../../../icons/ReferralIconV2.js';
import '../../../icons/MoneyIconV2.js';
import '../../../icons/UsersIconV3.js';
import '../../../icons/InfoFillV2.js';
import '../../../icons/LockOrange.js';
import '../../../icons/LockV2.js';
import '../../../icons/AlertOrange.js';
import '../../../icons/LiveSupportV2.js';
import '../../../icons/Chat.js';
import '../../../icons/CrossCircle.js';
import '../../../icons/LockV3.js';
import '../../../icons/CoinCrypto.js';
import { useWindowSize } from '../../../../utils/hooks/useWindowSize.js';
import { RangeMarks } from './RangeMarks/index.js';
import styles from './index.module.scss.js';

const Range = ({
  onChange = () => {
  },
  min = 0,
  max = 100,
  minAvailable = 0,
  maxAvailable = 100,
  step = 1,
  values = [0],
  alwaysShowExtremum,
  texts = {
    label: "Select your value"
  },
  className,
  style,
  ...props
}) => {
  const { windowSize } = useWindowSize();
  const ref = useRef(null);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles["styled-range"], className),
      style,
      ...props,
      ref
    },
    /* @__PURE__ */ React.createElement(
      Range$1,
      {
        label: texts.label,
        step,
        min,
        max: maxAvailable,
        values,
        onChange: (v) => {
          onChange(v[0] >= minAvailable ? v : [minAvailable]);
        },
        renderTrack: ({ props: trackProps, children }) => /* @__PURE__ */ React.createElement(
          "div",
          {
            className: cx(styles["range-track-wrapper"], "track"),
            ...trackProps,
            style: {
              ...trackProps.style,
              "--track-width": `${maxAvailable}%`
            }
          },
          /* @__PURE__ */ React.createElement(
            "div",
            {
              className: cx(styles["left-range-track"]),
              style: {
                "--left-width": `${values[0] / (maxAvailable / 100)}%`
              }
            },
            values[0] > 10 && `${values[0]}%`
          ),
          /* @__PURE__ */ React.createElement(
            "div",
            {
              className: cx(styles["right-range-track"]),
              style: {
                "--right-width": `${maxAvailable - values[0] + (max - maxAvailable)}%`,
                "--disable-diff": `${(max - maxAvailable) * -1}%`
              }
            },
            values[0] < max - 10 && `${(max - values[0]).toFixed(0)}%`
          ),
          children
        ),
        renderThumb: ({ props: thumbProps }) => /* @__PURE__ */ React.createElement(
          "div",
          {
            className: cx(styles.thumb),
            ...thumbProps,
            key: thumbProps.key,
            style: {
              ...thumbProps.style
            }
          }
        )
      }
    ),
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.scale),
        style: {
          "--max-count": max
        }
      },
      Array.from({
        length: max + 1
      }).map((_, i) => {
        if (i !== 0 && i !== 100 && i % step) return null;
        if (windowSize.width < 767 && i !== maxAvailable + step && i % 20) {
          return null;
        }
        const isAvailableRange = i < maxAvailable && i > minAvailable;
        const isExtremumPosition = i === minAvailable || i === maxAvailable;
        const isOnExtremum = (values[0] === minAvailable || values[0] === maxAvailable) && values[0] === i;
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            style: {
              opacity: isAvailableRange || isOnExtremum ? 1 : 0.32,
              color: isOnExtremum ? "rgb(0, 255, 255)" : "#fff",
              "--reward-lock-color": isAvailableRange || isOnExtremum ? "rgb(0, 255, 255)" : "#fff"
            },
            className: i === maxAvailable ? "max-available" : i === maxAvailable + step ? "locked-range" : ""
          },
          /* @__PURE__ */ React.createElement(
            "span",
            {
              style: {
                opacity: i % 10 && !isExtremumPosition ? 0 : 1
              }
            },
            (i === maxAvailable || i === minAvailable) && /* @__PURE__ */ React.createElement(Lock, { className: cx(styles["reward-lock"]) }),
            /* @__PURE__ */ React.createElement("span", null, i === 0 ? "00" : i % 10 && (!isExtremumPosition || !alwaysShowExtremum) ? "" : i)
          )
        );
      })
    )
  );
};
Range.displayName = "Range";
Range.RangeMarks = RangeMarks;

export { Range };
//# sourceMappingURL=index.js.map
